// Regra de parcelamento sem juros (informada pelo Arthur em 06/10/2026, a
// confirmar com cada seguradora): compras acima de R$ 700 em até 12x;
// até R$ 700, em até 6x. Para mudar a regra, altere só aqui.
export const INSTALLMENTS_THRESHOLD = 700;
export const MAX_INSTALLMENTS_LOW = 6;
export const MAX_INSTALLMENTS_HIGH = 12;

export const maxInstallments = (total) =>
  total > INSTALLMENTS_THRESHOLD ? MAX_INSTALLMENTS_HIGH : MAX_INSTALLMENTS_LOW;
